// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation-breadcrumb-menu {
  margin-right: 4px;
  flex-shrink: 0;
}
.dl-core-navigation-breadcrumb-menu__icon {
  color: var(--g-color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/NavigationBreadcrumbs/BreadcrumbMenu.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;AACJ;AACI;EACI,oCAAA;AACR","sourcesContent":[".dl-core-navigation-breadcrumb-menu {\n  margin-right: 4px;\n  flex-shrink: 0;\n}\n.dl-core-navigation-breadcrumb-menu__icon {\n  color: var(--g-color-text-secondary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
